export default "__VITE_ASSET__Ctn4zeoQ__"